import React, { useState } from "react";
import { Grid } from "@material-ui/core";
import { BiInfoCircle } from "react-icons/bi";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import { HiOutlineTicket } from "react-icons/hi";
import HtmlTooltip from "@mui/material/Tooltip";
import { Assort } from "../../../models/Assort";
import { useTranslation } from "react-i18next";
interface IProps {
  item: Assort;
  onAddLine: (assort: Assort, qnt: number) => void;
}

const AssortLine: React.FC<IProps> = ({ item, onAddLine }: IProps) => {
  const { t } = useTranslation();
  const isDesktop = useDesktopSize();
  const [qnt, setQnt] = useState<number>(0);
  return (
    <React.Fragment>
      <div className="ticket-line-left flex-start-center">
        <div className="flex-between-center">
          <HiOutlineTicket className="ticket-line-icon" />
          <b>{item.name}</b>
        </div>

        {isDesktop ? (
          <HtmlTooltip
            placement="right"
            title={
              <React.Fragment>
                <article
                  className="tooltip-description"
                  dangerouslySetInnerHTML={{ __html: item.description }}
                ></article>
              </React.Fragment>
            }
          >
            <b>
              <BiInfoCircle className="tooltip-icon" />
            </b>
          </HtmlTooltip>
        ) : (
          <b>
            <BiInfoCircle className="tooltip-icon" />
          </b>
        )}
      </div>

      <div className="ticket-line-right flex-end-center">
        <b className="price">
          {item.price} {t("zl")}
        </b>

        <div className="qnt flex-center-center">
          {qnt === 0 ? (
            <button className="flex-center-center qnt-button qnt-opacity onclick-button-move-up">-</button>
          ) : (
            <button
              className="flex-center-center qnt-button onclick-button-move-up"
              onClick={() => {
                onAddLine(item, -1);
                setQnt(qnt - 1);
              }}
            >
              -
            </button>
          )}

          <input className="qnt-input" type="number" value={qnt} />

          <button
            className="flex-center-center qnt-button onclick-button-move-up"
            onClick={() => {
              onAddLine(item, 1);
              setQnt(qnt + 1);
            }}
          >
            +
          </button>
        </div>

        {/* 
            <div className="qnt flex-end-center">
              <button onClick={() => onAddLine(item)} className="button medium padding-medium button-fill-main">
                Dodaj <MdAddShoppingCart className="icon" />
              </button>
            </div> */}
      </div>
    </React.Fragment>
  );
};

export default AssortLine;
